import Switch_1 from './switch-1';
import Switch_2 from './switch-2';
import Switch_3 from './switch-3';
import Switch_4 from './switch-4';
import Switch_5 from './switch-5';
import Switch_6 from './switch-6';
import Switch_7 from './switch-7';
import Switch_8 from './switch-8';
import Switch_9 from './switch-9';
import Switch_10 from './switch-10';
import Switch_11 from './switch-11';
import Switch_12 from './switch-12';
import Switch_13 from './switch-13';
import Switch_14 from './switch-14';
import Switch_15 from './switch-15';
import Switch_16 from './switch-16';
import Switch_17 from './switch-17';
import Switch_18 from './switch-18';
import Switch_19 from './switch-19';

export {
    Switch_1,
    Switch_2,
    Switch_3,
    Switch_4,
    Switch_5,
    Switch_6,
    Switch_7,
    Switch_8,
    Switch_9,
    Switch_10,
    Switch_11,
    Switch_12,
    Switch_13,
    Switch_14,
    Switch_15,
    Switch_16,
    Switch_17,
    Switch_18,
    Switch_19,
};